import { crossbell } from 'viem/chains';
export { crossbell } from 'viem/chains';
import { defineChain } from 'viem/chains/utils';

// src/network/index.ts
var crossbellTestnet = /* @__PURE__ */ defineChain({
  id: 3636,
  name: "Crossbell L2 Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.crossbell.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "CrossScan Testnet",
      url: "https://scan.testnet.crossbell.io/"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 0
    }
  },
  testnet: true
});

// src/network/index.ts
var CONTRACT_ADDRESS = {
  ENTRY: "0xa6f969045641Cf486a747A2688F3a5A6d43cd0D8",
  PERIPHERY: "0x96e96b7af62d628ce7eb2016d2c1d2786614ea73",
  NEWBIE_VILLA: "0xD0c83f0BB2c61D55B3d33950b70C59ba2f131caA",
  CBT: "0x3D1b588a6Bcd728Bb61570ced6656eA4C05e404f",
  TIPS: "0x0058be0845952D887D1668B5545de995E12e8783",
  TIPS_WITH_CONFIG: "0xF1375C069998d06E123B800cF0566e44DA1BE30E",
  TIPS_WITH_FEE: "0xf3158018f932981d0005701dDC22Ce51477E436d",
  MIRA: "0xAfB95CC0BD320648B3E8Df6223d9CDD05EbeDC64",
  LINKLIST: "0xFc8C75bD5c26F50798758f387B698f207a016b6A",
  GCSB: "0x4200000000000000000000000000000000000301"
};
var JSON_RPC_ADDRESS;
function getJsonRpcAddress() {
  return JSON_RPC_ADDRESS;
}
function setJsonRpcAddress(address) {
  JSON_RPC_ADDRESS = address;
}
async function isCrossbellMainnet(client) {
  return await client.getChainId() === crossbell.id;
}
async function isCrossbellTestnet(client) {
  return await client.getChainId() === crossbellTestnet.id;
}
async function isCrossbellChain(client) {
  const chainId = await client.getChainId();
  return chainId === crossbell.id || chainId === crossbellTestnet.id;
}

export { CONTRACT_ADDRESS, crossbellTestnet, getJsonRpcAddress, isCrossbellChain, isCrossbellMainnet, isCrossbellTestnet, setJsonRpcAddress };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-Z5ML27IN.mjs.map